const selectCampaigns = (state) => {
    return state.calculation.campaigns;
};

const selectCampaignModalState = (state) => {
    return state.calculation.isCampaignModalOpen;
};

const selectAddressModalState = (state) => {
    return state.calculation.isAddressModalOpen;
};

const selectPaymentPlan = state => {
    return state.calculation.paymentPlan;
}

const selectIsAddressModalOpen = state => {
    return state.calculation.isAddressModalOpen;
}

const selectHasAddress = state => {
    return state.calculation.hasAddress;
}

const selectHasPersonalInfo = state => {
    return state.calculation.hasPersonalInfo;
}

export {
    selectCampaigns,
    selectCampaignModalState,
    selectPaymentPlan,
    selectAddressModalState,
    selectIsAddressModalOpen,
    selectHasAddress,
    selectHasPersonalInfo
}